// Reminder: customers in this period with Google-form tips still pending review (these block statement sending).
// Part of the Balances page (components/Balances.jsx). Split out 2026-10-14.

export default function PendingReminder({ customers, data, from, recon, to, totals }) {
  return (
    <>
      {/* PENDING RECONCILIATION REMINDER (Suresh 2026-07-08).
          Shown whenever any customer in the current window has
          pending Google-form rows. These block statement sending
          because the totals shown here don't yet reflect the
          pending items. Banner lists the specific customers so
          finance knows who to chase. Reads straight from data.customers
          — the recon output already carries pendingTips per customer. */}
      {data && Array.isArray(data.customers) && (() => {
        const pending = data.customers.filter(c => c.pendingTips && c.pendingTips.count > 0);
        if (pending.length === 0) return null;
        const totalRows = pending.reduce((s, c) => s + c.pendingTips.count, 0);
        const totalVal  = pending.reduce((s, c) => s + (Number(c.pendingTips.totalValue) || 0), 0);
        return (
          <div style={{
            padding: '0.6rem 0.9rem',
            marginBottom: '0.75rem',
            background: '#fff4e5',
            border: '1px solid #f59e0b',
            borderRadius: 6,
            color: '#78350f'
          }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.55rem', flexWrap: 'wrap' }}>
              <strong>⏸ Statements blocked by pending items:</strong>
              <span className="small">{pending.length} customer{pending.length === 1 ? '' : 's'} · {totalRows} unapproved row{totalRows === 1 ? '' : 's'} · ${totalVal.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
            </div>
            <div className="small" style={{ marginTop: '0.35rem' }}>
              These customers still show on Balances (the pending value is included as "Ending w/ pending") but their <strong>Send</strong> button is hidden in the Statements modal until the operator approves the Google-form rows in the Tips inbox.
            </div>
            <div className="small" style={{ marginTop: '0.35rem' }}>
              <strong>Blocked:</strong>{' '}
              {pending
                .sort((a, b) => (b.pendingTips.totalValue || 0) - (a.pendingTips.totalValue || 0))
                .slice(0, 12)
                .map(c => c.customer + ' (' + c.pendingTips.count + ')')
                .join(', ')}
              {pending.length > 12 ? ', … +' + (pending.length - 12) + ' more' : ''}
            </div>
          </div>
        );
      })()}
    </>
  );
}
